import { Routes } from '@angular/router';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';

const PARTNER_APP_PLAY_STORE_URL =
    'https://play.google.com/store/apps/details?id=com.inventlabs.okitopartner';

export const routes: Routes = [
    { path: 's/:audience/:code', loadComponent: () => import('./referral/referral.component').then(m => m.ReferralComponent) },
    { path: '', component: LandingPageComponent },
    {
        path: 'partner-app',
        // A guard still needs a valid route target; it cancels activation below.
        component: LandingPageComponent,
        canActivate: [
            () => {
                window.location.href = PARTNER_APP_PLAY_STORE_URL;
                return false;
            },
        ],
    },
    // { path: 'partner', component: PartnerLandingPageComponent },

    // { path: 'privacy', component: PrivacyPolicyComponent },
    // { path: 'tnc', component: TermsConditionsComponent },
    // { path: 'accessibility', component: AccessPolicyComponent },
    // { path: 'web_terms', component: WebTermsComponent },

    // { path: 'partner/about_us', component: AboutUsPage },
    // { path: 'partner/join_us', component: JoinUsPage },
    // { path: 'partner/perks', component: PartnerPerksComponent },
    { path: '**', redirectTo: '' },
];
